export default __webpack_public_path__ + "static/media/img (3).3504c409.jpg";